import { FC, forwardRef, InputHTMLAttributes, LegacyRef } from 'react';
import { cn } from '@/utils/classNames.ts';
import { TextareaProps } from 'react-daisyui';
type TextAreaProps = Omit<InputHTMLAttributes<HTMLTextAreaElement>, 'size' | 'color'> &
  Pick<TextareaProps, 'size' | 'color' | 'bordered' | 'rows'> & {
    label?: string;
    error?: string;
    wrapperClassName?: string;
    hideError?: boolean;
  } & { ref?: LegacyRef<HTMLTextAreaElement> };

const TextArea: FC<TextAreaProps> = forwardRef(
  ({ label, error, wrapperClassName, size = 'md', color, bordered = true, hideError = false, ...args }, ref) => {
    return (
      <div className={cn('form-control max-w-full w-full', wrapperClassName)}>
        {label ? (
          <label className="label">
            <span
              className={cn('label-text', {
                'text-ghost': color === 'ghost',
                'text-primary': color === 'primary',
                'text-secondary': color === 'secondary',
                'text-accent': color === 'accent',
                'text-info': color === 'info',
                'text-success': color === 'success',
                'text-warning': color === 'warning',
              })}
            >
              {label}
            </span>
          </label>
        ) : null}
        <textarea
          className={cn('textarea', {
            'textarea-ghost': color === 'ghost',
            'textarea-primary': color === 'primary',
            'textarea-secondary': color === 'secondary',
            'textarea-accent': color === 'accent',
            'textarea-info': color === 'info',
            'textarea-success': color === 'success',
            'textarea-warning': color === 'warning',
            'textarea-error': error || color === 'error',
            'textarea-xs': size === 'xs',
            'textarea-sm': size === 'sm',
            'textarea-md': size === 'md' || size,
            'textarea-lg': size === 'lg',
            'textarea-bordered': bordered,
          })}
          ref={ref}
          {...args}
        />
        {!hideError && !!error ? (
          <label className="label">
            <span className="label-text-alt text-error">{error}</span>
          </label>
        ) : null}
      </div>
    );
  }
);

export default TextArea;
